import { inject, injectable } from "@launchtray/tsyringe-async";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { PromiseCompletionSource } from "by/gamefactory/shared/async/PromiseCompletionSource";
import { Viewable } from "by/gamefactory/scene/viewable/Viewable";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { CommonResourcesPackage } from "../../common/resources/CommonResourcesPackage";
import { IListInMpNotificationController } from "./controllers/IListInMpNotificationController";
import { ListInMpNotificationPopupView } from "./view/ListInMpNotificationPopupView";
import { ListInMpNotificationResourcePackage } from "./resources/ListInMpNotificationResourcePackage";
import { TopPanel } from "../../game/components/toppanel/TopPanel";

@injectable()
export class ListInMpNotificationPopupScene extends Viewable<void> {
    public constructor(
        commonResources: CommonResourcesPackage,
        listNotificationResources: ListInMpNotificationResourcePackage,
        topPanel: TopPanel,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("IListInMpNotificationController") listInNotificationController: IListInMpNotificationController,
        @inject("ILogger") logger: ILogger
    ) {
        super();
        const pcs = new PromiseCompletionSource<void>();
        this.view = new ListInMpNotificationPopupView(
            pcs,
            commonResources,
            listNotificationResources,
            canvasScaler,
            listInNotificationController,
            logger
        );
        const topPanelOnNotification = topPanel.onNotificationLayer;
        topPanel.bringToOriginParent(true);
        pcs.result.then(() => {
            this.operationControls.complete();
            if (topPanelOnNotification) {
                topPanel.bringToFront();
            }
        }, (error: unknown) => {
            this.operationControls.error(error);
            if (topPanelOnNotification) {
                topPanel.bringToFront();
            }
        });
    }
}
